export default {
    SELECT_DOCUMENT: "Выберите документ для просмотра объектов навигации",
    NO_NAVIGATION_OBJECTS: "Нет объектов навигации"
};
